







































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Maintenance } from "@/models/maintenance";
import { MaintenanceElementCategory, MaintenanceListElementEntry } from "@/models/maintenanceListElementEntry";
import { parseMaintenanceList, serializeMaintenanceList } from '@/utils/maintenanceListUtils';

// TODO: Continue here!!!
// TODO: Continue here!!!
// TODO: Continue here!!!

@Component({
  components: {
    MaintenanceListRadio: () => import('./../components/radio/MaintenanceListRadio.component.vue'),
    MaintenanceListTableRow: () => import('./../components/MaintenanceListTableRow.component.vue'),
  }
})
export default class EditChecklistComponent extends Vue {

  data() {
    return {
      valid: false,
      required(propertyType: any) {
        return (v: any) => v && v.length > 0 || `You must input a ${propertyType}`;
      },
      maxLength(propertyType: any, maxLength: number) {
        return (v: any) => v && v.length <= maxLength || `${propertyType}  must have max  ${maxLength} characters`;
      },
      minLength(propertyType: any, min: number) {
        return (v: any) => v && v.length >= min || `${propertyType}  must have minimum  ${min} characters`;
      }
    }
  }

  @Prop({ default: () => new Maintenance({}) })
  public maintenance!: Maintenance;

  public conditionList: MaintenanceListElementEntry[] = [];
  public functionList: MaintenanceListElementEntry[] = [];

  public mounted() {
    const list = this.getMaintenanceListEntries();
    this.conditionList = list.filter((arg) => arg.category === MaintenanceElementCategory.condition);
    this.functionList = list.filter((arg) => arg.category === MaintenanceElementCategory.function);
  }

  private getMaintenanceListEntries(): MaintenanceListElementEntry[] {
    return parseMaintenanceList(this.maintenance?.maintenanceList).map((entry) =>
      entry instanceof MaintenanceListElementEntry ? entry : new MaintenanceListElementEntry(entry)
    );
  }

  public closeDialog() {
    this.$emit('closeDialog', { saved: false });
  }

  public async saveChecklist() {
    const entries = [...this.conditionList, ...this.functionList];
    (this.maintenance as any).maintenanceList = serializeMaintenanceList(entries);
    this.$emit('closeDialog', { saved: true });
  }

}

